<template>
    <v-app id="inspire" style="background-image: url('/bckAlumno.png'); background-repeat: no-repeat; background-position: right bottom 1%; background-color:#E3F2FD">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-card elevation="3" class="ma-2">
            <v-row>
                <v-col fluid class="pa-0 pl-5">
                    <v-list-item-avatar color="white" size="30" class="ma-0">
                        <v-icon size="30" color="blue">face</v-icon>
                    </v-list-item-avatar>
                    <span class="title blue--text ma-4">Seguimiento al Estudiante</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="8" lg="4" class="pa-0 pl-5 pb-1">
                    <div class="d-flex align-center">
                        <v-combobox
                            ref="cboxSearch"
                            @change="fuPriAlumnoSelection"
                            @keyup.enter="fuSearch"
                            :loading="disLoadingSearch"
                            v-model="dSearch"
                            :items="dPriAlumnos"
                            item-value="IdAlumno"
                            item-text="AlumnoDNICodigo"
                            label="Buscar por Código o DNI o Apellidos"
                            dense filled rounded clearable hide-details>
                            <template v-slot:item="{ item }">
                                <!-- <v-list-item-avatar
                                    color="indigo"
                                    class="text-h5 font-weight-light white--text"
                                    >
                                    {{ item.Alumno.charAt(0) }}
                                </v-list-item-avatar> -->
                                <v-list-item-content>
                                    <v-list-item-title>{{item.Alumno}}</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-icon size="20" color="blue">credit_card</v-icon>{{item.DNI}} 
                                        <v-icon size="20" color="blue">code</v-icon>{{item.Codigo}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-chip class="ma-2" :color="fuServicioInicialColorLocal(item.Iniciales)" outlined>{{item.Iniciales}}</v-chip>
                                </v-list-item-action>
                            </template>
                        </v-combobox>
                        <v-btn @click="fuSearch" :loading="disLoadingSearch" class="mx-2" fab dark small color="primary">
                            <v-icon dark>
                                search
                            </v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                    <v-card v-if="dPriAlumno.IdAlumno" min-width="600" class="bsp_header">
                        <v-row align="center">
                            <v-col cols="2" sm="2" md="2" lg="2" align="center">
                                <v-avatar v-if="dPriAlumno.Foto==''" size="85" class="ma-1">
                                    <img src="@/assets/images/businessman.png" alt="Postulante">
                                </v-avatar>
                                <v-hover v-else v-slot:default="{ hover , props }">
                                    <v-img
                                        v-bind="props"
                                        :src="dPriAlumno.Foto"
                                        alt="Foto del Alumno"
                                        :class="{ 'hover-scale': hover  }"
                                        contain
                                        max-height="85"
                                    />
                                </v-hover>
                            </v-col>
                            <v-col cols="4" sm="4" md="4" lg="3">
                                <v-list-item>
                                    <v-list-item-content dark>
                                        <v-list-item-subtitle class="white--text"><v-icon title="Apellidos y Nombres" size="20" dark>face</v-icon> {{dPriAlumno.Alumno}}<v-icon size="15" @click="fuCopy(dPriAlumno.Alumno)" right dark>content_copy</v-icon></v-list-item-subtitle>
                                        <v-list-item-subtitle class="white--text"><v-icon :title="dPriAlumno.IdAlumno" @click="fuCopy(dPriAlumno.IdAlumno)" size="20" dark>qr_code_2</v-icon> {{dPriAlumno.Codigo}}<v-icon size="15" @click="fuCopy(dPriAlumno.Codigo)" right dark>content_copy</v-icon></v-list-item-subtitle>
                                        <v-list-item-subtitle class="white--text"><v-icon title="Programa Académico" size="20" dark>school</v-icon> {{dPriAlumno.priservicio.Descripcion}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="5" sm="5" md="5" lg="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="white--text"><v-icon title="DNI" size="20" dark>credit_card</v-icon> {{dPriAlumno.DNI}}<v-icon size="15" @click="fuCopy(dPriAlumno.DNI)" right dark>content_copy</v-icon></v-list-item-subtitle>
                                        <v-list-item-subtitle class="white--text" title="Celular">
                                            <v-text-field @click:append="fuAlumnoSave()" @keyup.enter="fuAlumnoSave()" v-model="dPriAlumno.Celular" prepend-inner-icon="phone_android" append-icon="save" :disabled="dIsUpdatingCelular" :loading="dIsUpdatingCelular" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off" clearable counter dense style="font-size: 25px !important;" dark></v-text-field>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="5" sm="5" md="5" lg="2">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle v-if="dPriAlumno.prialumnoegresado" class="white--text">
                                            <v-chip class="ma-2" color="deep-purple accent-4" text-color="white" small><v-icon left>school</v-icon><strong>EGRESADO: {{dPriAlumno.prialumnoegresado.Semestre}}</strong></v-chip>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-else >
                                            <v-chip class="ma-2" color="success" text-color="white"><v-icon left>face</v-icon><strong>ESTUDIANTE</strong></v-chip>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="1" sm="1" md="1" lg="1" align="center">
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                    <v-tabs v-model="dTab" v-if="dPriAlumno.IdAlumno">
                        <v-tab :value="1" @click="fuIframeShow('#idTramite')"><v-icon left>style</v-icon>Tramite</v-tab>
                        <v-tab :value="2"><v-icon left>attach_money</v-icon>Económico</v-tab>
                        <v-tab :value="3"><v-icon left>star_rate</v-icon>Matricula</v-tab>
                        <v-tab :value="4"><v-icon left>sort</v-icon>Ordenar Pagos</v-tab>
                        <v-tab :value="5" @click="fuIframeShow('#idNota')"><v-icon left>tag</v-icon>Nota Detalle</v-tab>
                        <v-tab :value="6"><v-icon left>tag</v-icon>Nota Final</v-tab>
                        <v-tab :value="7"><v-icon left>front_hand</v-icon>Asistencia</v-tab>
                        <v-tab :value="8"><v-icon left>question_answer</v-icon>Tutoria</v-tab>                        
                        <v-tab :value="9"><v-icon left>paid</v-icon>Pagar</v-tab>
                        <v-tab-item>
                            <iframe id="idTramite" :src="cUrlTramite" style="width: 100% !important; height: 1000px;" />
                        </v-tab-item>
                        <v-tab-item>
                            <CResumenPago :pIdAlumno="dPriAlumno.IdAlumno"/>
                        </v-tab-item>
                        <v-tab-item>
                            <CMatriculaByAlumno :pIdAlumno="dPriAlumno.IdAlumno"/>
                        </v-tab-item>
                        <v-tab-item>
                            <CVsColeProyCuota :pCodigo="dPriAlumno.Codigo"/>
                        </v-tab-item>
                        <v-tab-item>
                            <iframe id="idNota" :src="cUrlNota" style="width: 100% !important;" />
                        </v-tab-item>
                        <v-tab-item>
                            <CMatCursosMinisterioEgresado :pIdAlumno="parseInt(dPriAlumno.IdAlumno)" />
                        </v-tab-item>
                        <v-tab-item>
                            <CDcbAsistenciaMatricula :pIdAlumno="dPriAlumno.IdAlumno"/>
                        </v-tab-item>
                        <v-tab-item>
                            <CMatConsejeria :pIdAlumno="dPriAlumno.IdAlumno"/>
                        </v-tab-item>
                        <v-tab-item>
                            <iframe :src="cUrlDeuda" style="width: 100% !important;" height="1000px" />
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </v-card>
    </v-app>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapActions} from 'vuex';
import { fuCopy, fuServicioInicialColor } from '@/helpers/index.js';
import CMatConsejeria from '@/components/Academico/MatConsejeria.vue';
import CVsColeProyCuota from '@/components/Navasoft/VsColeProyCuota.vue';
import CMatCursosMinisterioEgresado from '@/components/Academico/MatCursosMinisterioEgresado.vue';
import CMatriculaByAlumno from '@/components/Academico/MatriculaByAlumno.vue';
import CResumenPago from '@/components/Ing/ResumenPago.vue';
import CDcbAsistenciaMatricula from '@/components/DCB/DcbAsistenciaMatricula.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'AlumnoGeneral',
    components: {CMatConsejeria, CMatCursosMinisterioEgresado, CMatriculaByAlumno, CResumenPago, CDcbAsistenciaMatricula, CVsColeProyCuota},
    mounted(){
        if (this.$route.params.pIdPersonal){
            this.fuLoginQuery(this.$route.params.pIdPersonal);
        }
        //this.fuPrialumno(50496); // 50496 yuly-  62610 DEBE 2  - 63747 20251G231 aller, matriculaExtemporanea 62497, 62626 EliminarDeuda, 62251 matriculaRegular, 60621 REINICIO, 52481 REINICIO,  RECUPERACION 58151, 84375 deuda antigua
    },
    data: () => ({
        dSearch: '',
        dLoading : false,
        disLoadingSearch : false,
        dIsUpdatingCelular: false,
        dPriAlumnos: [],
        dPriAlumno: {
            IdAlumno: '',
            DNI: '',
            Alumno: '',
            Codigo: '',
            Celular: '',
            Foto: '',
            priservicio: {
                IdServicio: '',
                Iniciales: '',
            }
        },
        dTab: null,
    }),
    computed: {
        cUrlNota: function () {
            return 'https://intranetiframe.khipu.edu.pe/AlumnoListaNotaTotal/' + this.dPriAlumno.IdAlumno + '?domain=http://intranet.khipu.net/Alumnos/frcvernotas_fichadcb&domain_type=false&seccion=0'
        },
        cUrlDeuda: function () {
            return 'https://pagos.khipu.edu.pe/ResumenPagos/1/' + this.dPriAlumno.IdAlumno + '/' + new Date().toISOString();
        },
        cUrlTramite: function () {
            return 'https://intranetiframe.khipu.edu.pe/tramiteDocumentario/' + this.dPriAlumno.IdAlumno + '/' + this.$route.params.pIdPersonal;
        },
    },
    methods: {
        ...mapActions(['saLogin', 'saLogout']),
        fuCopy,
        fuSearch() {
            this.dPriAlumno.IdAlumno = null;
            setTimeout(() => {
                if(this.dSearch.length>=4)
                    this.fuAlumnoSearch(this.dSearch);
            }, 500);
        },
        fuAddItem(event) {
            const newItem = event.target.value.trim();
            if(newItem.length>=4)
                this.fuAlumnoSearch(newItem);
        },
        fuServicioInicialColorLocal(vIniciales){
            return fuServicioInicialColor(vIniciales);
        },
        fuPriAlumnoSelection(vItem) {
            if(vItem){
                if(vItem.IdAlumno){
                    this.fuPrialumno(vItem.IdAlumno);
                    this.dTab = 0;
                }
            }
        },
        fuAlumnoSearch(vSearch){
            if(vSearch != ''){
                this.dPriAlumnos = [];
                if(vSearch.length==8 && !isNaN(vSearch))
                    this.fuPrialumnoByDNI(vSearch)
                else{
                    if(vSearch.length==9 && !isNaN(vSearch.substring(0,5)))
                        this.fuPrialumnoByCodigo(vSearch)
                    else
                        this.fuPrialumnoByAlumno(vSearch)
                }
            }
        },
        async fuPrialumno(pIdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!){
                        prialumno(IdAlumno: $IdAlumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Foto
                            priservicio{
                                Iniciales
                                Descripcion
                            }
                            prialumnoegresado{
                                Semestre
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: pIdAlumno,
                    },
                    fetchPolicy: 'no-cache'
                })
                this.dPriAlumno = response.data.prialumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.disLoadingSearch = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!){
                        prialumnoByCodigo(Codigo: $Codigo){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo
                    }
                })
                let item = response.data.prialumnoByCodigo;
                if(item){
                    this.dPriAlumnos.push({
                        IdAlumno: item.IdAlumno,
                        Alumno: item.Alumno,
                        Codigo: item.Codigo,
                        DNI: item.DNI,
                        Iniciales: item.priservicio.Iniciales,
                        AlumnoDNICodigo: item.Alumno + ' - '+ item.DNI + ' - '+ item.Codigo
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.disLoadingSearch = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.disLoadingSearch = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                this.dPriAlumnos = response.data.prialumnoByDNI.map(item =>{
                    return {
                        IdAlumno: item.IdAlumno,
                        Alumno: item.Alumno,
                        Codigo: item.Codigo,
                        DNI: item.DNI,
                        Iniciales: item.priservicio.Iniciales,
                        AlumnoDNICodigo: item.Alumno + ' - '+ item.DNI + ' - '+ item.Codigo
                    }
                })
            } catch (error) {
                console.log(error);
            } finally {
                this.disLoadingSearch = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.disLoadingSearch = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!){
                        prialumnoByAlumno(Alumno: $Alumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno
                    }
                })
                this.dPriAlumnos = response.data.prialumnoByAlumno.map(item =>{
                    return {
                        IdAlumno: item.IdAlumno,
                        Alumno: item.Alumno,
                        Codigo: item.Codigo,
                        DNI: item.DNI,
                        Iniciales: item.priservicio.Iniciales,
                        AlumnoDNICodigo: item.Alumno + ' - '+ item.DNI + ' - '+ item.Codigo
                    }
                })
            } catch (error) {
                console.log(error);
            } finally {
                this.disLoadingSearch = false
            }
        },
        fuIframeShow(vId){
            setTimeout(() => {
                if (typeof window.iFrameResize !== 'undefined') window.iFrameResize({log: false}, vId)
            }, 1000);
        },
        async fuLoginQuery(vIdPersonal){
            try {
                const response = await this.$apollo.query({
                    query: gql`query pripersonal($IdPersonal: Int!){
                        pripersonal(IdPersonal:$IdPersonal){
                            IdPersonal
                            Usuario
                            Personal
                            IdKhipuPlus
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdPersonal: vIdPersonal
                    }
                })
                if(response.data.pripersonal){
                    localStorage.setItem('ssUser', JSON.stringify(response.data.pripersonal));
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error en la conexión.', 'error');
                this.saLogout();
            } finally {
            }
        },
        fuAlumnoSave () {
            if(this.dPriAlumno.Celular==''){
                Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'Ingrese el número de celular.'})
            } else {
                this.fuAlumnoUpdate();
            }
        },
        async fuAlumnoUpdate () {
            try {
                this.dIsUpdatingCelular = true;

                const data = {
                    FechaMod : moment().format("YYYYMMDD HH:mm:ss"),
                    Celular: this.dPriAlumno.Celular,
                }

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoUpdate($IdAlumno: ID!, $input: prialumnoUpdateInput!){
                        prialumnoUpdate(IdAlumno: $IdAlumno, input: $input){
                            IdAlumno
                            ApPaterno
                            ApMaterno
                            Nombres
                            Codigo
                            IdServicio
                            priservicio{
                                Descripcion
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: this.dPriAlumno.IdAlumno,
                        input: data
                    }
                });
                if(response.data){
                    Swal.fire({icon: 'success', title: 'Correcto', html: 'Se modificó correctamente.<br>'})
                } else {
                    Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'No se guardó.<br>' + 'Intente de nuevo o comuníquese con el AREA DE TI.'})
                }
            } catch (error) {
                console.log(error);
                Swal.fire({icon: 'error',title: '¡ ERROR !',html: 'No se guardó.<br>' + 'Intente de nuevo o comuníquese con el AREA DE TI.'})
            } finally {
                this.dIsUpdatingCelular = false;
            }
        },
    }
}
</script>
<style scoped>
    .hover-scale {
        transform: scale(3);
        transition: transform 0.3s ease-in-out;
    }
    .bsp_header {
        background: linear-gradient(130deg, transparent 0% 87%, rgba(255, 255, 255, .6) 87.1% 100%),
                    linear-gradient(130deg, transparent 0% 75%, rgba(255, 255, 255, .4) 75.1% 100%),
                    linear-gradient(90deg, transparent 0% 35%, rgba(255, 255, 255, .3) 65.1% 100%),
                    linear-gradient(130deg, transparent 0% 60%, rgba(255, 255, 255, .2) 60.1% 100%),
                    linear-gradient(90deg, #3498db 0%, #2980b9 100%); /* Color base reemplazando var(--headerPrimary) */
        color: white;
    }
</style>
